/**
 * Получить access токен из localStorage
 */
export const getToken = () => {
  return localStorage.getItem('access_token');
};

/**
 * Сохранить access токен в localStorage
 */
export const setToken = (token) => {
  if (token) {
    localStorage.setItem('access_token', token);
  }
};

/**
 * Получить refresh токен из localStorage
 */
export const getRefreshToken = () => {
  return localStorage.getItem('refresh_token');
};

/**
 * Сохранить refresh токен в localStorage
 */
export const setRefreshToken = (token) => {
  if (token) {
    localStorage.setItem('refresh_token', token);
  }
};

/**
 * Удалить все токены из localStorage
 */
export const removeTokens = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
};

/**
 * Декодировать JWT токен и получить payload
 */
export const getTokenPayload = (token) => {
  try {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));
    
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Error decoding token:', error);
    return null;
  }
};

/**
 * Проверить, истёк ли токен
 */
export const isTokenExpired = (token) => {
  try {
    const payload = getTokenPayload(token);
    if (!payload || !payload.exp) {
      return true;
    }
    
    const expirationTime = payload.exp * 1000; // Конвертируем в миллисекунды
    return Date.now() >= expirationTime;
  } catch (error) {
    console.error('Error checking token expiration:', error);
    return true;
  }
};

/**
 * Получить время до истечения токена в миллисекундах
 */
export const getTokenExpirationTime = (token) => {
  try {
    const payload = getTokenPayload(token);
    if (!payload || !payload.exp) {
      return 0;
    }
    
    const expirationTime = payload.exp * 1000;
    return Math.max(0, expirationTime - Date.now());
  } catch (error) {
    console.error('Error getting token expiration time:', error);
    return 0;
  }
};
